var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.419325 0.419325C0.687899 0.150831 1.05212 0 1.43188 0C1.81164 0 2.17586 0.150831 2.44444 0.419325L7.50865 5.48354L12.5729 0.419325C12.843 0.15844 13.2047 0.0140841 13.5803 0.0173472C13.9558 0.0206103 14.315 0.171232 14.5805 0.436771C14.8461 0.70231 14.9967 1.06152 14.9999 1.43703C15.0032 1.81255 14.8589 2.17432 14.598 2.44444L9.53376 7.50865L14.598 12.5729C14.8589 12.843 15.0032 13.2047 14.9999 13.5803C14.9967 13.9558 14.8461 14.315 14.5805 14.5805C14.315 14.8461 13.9558 14.9967 13.5803 14.9999C13.2047 15.0032 12.843 14.8589 12.5729 14.598L7.50865 9.53376L2.44444 14.598C2.17432 14.8589 1.81255 15.0032 1.43703 14.9999C1.06152 14.9967 0.70231 14.8461 0.436771 14.5805C0.171232 14.315 0.0206103 13.9558 0.0173472 13.5803C0.0140841 13.2047 0.15844 12.843 0.419325 12.5729L5.48354 7.50865L0.419325 2.44444C0.150831 2.17586 0 1.81164 0 1.43188C0 1.05212 0.150831 0.687899 0.419325 0.419325V0.419325Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3fbbd5c1a9c2628cce358282796fd951.svg";
export { ForwardRef as ReactComponent };